import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { ComponentStatus, SpinnerSize } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.size-small]': 'size() === SpinnerSize.SMALL',
    '[class.size-medium]': 'size() === SpinnerSize.MEDIUM',
    '[class.size-large]': 'size() === SpinnerSize.LARGE',
    '[class.status-primary]': 'status() === ComponentStatus.PRIMARY',
    '[class.status-secondary]': 'status() === ComponentStatus.SECONDARY',
    '[class.status-success]': 'status() === ComponentStatus.SUCCESS',
    '[class.status-warning]': 'status() === ComponentStatus.WARNING',
    '[class.status-danger]': 'status() === ComponentStatus.DANGER',
  },
})
export class SpinnerComponent {
  public readonly imageSrc: InputSignal<string | undefined> = input();
  public readonly size: InputSignal<SpinnerSize> = input<SpinnerSize>(
    SpinnerSize.MEDIUM,
  );
  public readonly status: InputSignal<ComponentStatus> = input<ComponentStatus>(
    ComponentStatus.PRIMARY,
  );

  protected readonly SpinnerSize: typeof SpinnerSize = SpinnerSize;
  protected readonly ComponentStatus: typeof ComponentStatus = ComponentStatus;
}
